import { render, staticRenderFns } from "./script-draft-list.vue?vue&type=template&id=12bf1871&scoped=true"
import script from "./script-draft-list.vue?vue&type=script&setup=true&lang=js"
export * from "./script-draft-list.vue?vue&type=script&setup=true&lang=js"
import style0 from "./script-draft-list.vue?vue&type=style&index=0&id=12bf1871&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf1871",
  null
  
)

export default component.exports